import { createContext, useContext } from 'react';

interface AccordionAutoScrollContextValue {
  autoScrollMargin?: string;
}

export const AccordionAutoScrollContext =
  createContext<AccordionAutoScrollContextValue>({
    autoScrollMargin: undefined,
  });

export const useAutoScroll = () => {
  const context = useContext(AccordionAutoScrollContext);
  if (context === undefined) {
    throw new Error('useAutoScroll must be used within an Accordion');
  }

  return context;
};
